<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ParameterCard, Alert, ParameterCardV2 } from '@Shelly/shelly-design-system';
	import ControlTempScheme from '../../Controls/TemperatureSchemes/ControlTempScheme.svelte';
	import ControlEnableTempScheme from '../../Controls/TemperatureSchemes/ControlEnableTempScheme.svelte';
	import { capFirstChar } from '../../../helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let type = 'cool';
	export let units = 'C';
	export let thermostatDefTemp = 21;
	export let id = '-1';
	export let showToggleBtn = true;
	export let showWheelTitle = false;
	export let showType = false;
	export let extSensorValue;
	export let sensorIsOnline: boolean;
	export let extSensor;

	let mode = capFirstChar(
		type === 'cool'
			? $format('label_cooling', { default: 'cooling' })
			: $format('label_heating', { default: 'heating' }),
	);

	$: internal_temperature = extSensorValue || null;

	$: sensorIsDeleted = typeof extSensor === 'undefined' || extSensor?.deleted;
	$: disabled = !sensorIsOnline || sensorIsDeleted;

	function generateWarningNotification(sensorIsOffline, sensorIsDeleted) {
		if (sensorIsOffline && !sensorIsDeleted) {
			let notification = {
				heading: $format('error_heading_offline_sensor_in_thermostat', {
					values: {
						name: extSensor?.name,
					},
					default: 'Control thermostat is disabled',
				}),
				message: $format('error_message_offline_sensor_in_thermostat', {
					values: {
						name: `"${extSensor?.name}"`,
					},
					default: `Your main sensor "${extSensor?.name}" is offline.`,
				}),
			};
			return notification;
		}
		if (sensorIsDeleted) {
			let notification = {
				heading: $format('error_heading_offline_sensor_in_thermostat', {
					values: {
						name: extSensor?.name,
					},
					default: 'Control thermostat is disabled',
				}),
				message: $format('error_deleted_sensor_in_thermostat', {
					values: {
						id: extSensor?.id,
					},
					default: `Sensor ${extSensor?.id} was deleted from your account. You can add new one by editing the thermostat.`,
				}),
			};
			return notification;
		}
	}

	$: warningNotification = generateWarningNotification(Boolean(!sensorIsOnline), sensorIsDeleted);
</script>

{#if disabled}
	<Alert
		class="mb-s"
		type="warning"
		heading={warningNotification?.heading}
		message={warningNotification?.message}
	/>
{:else if showType}
	{#if $showNewLayout}
		<ParameterCardV2
			class="mb-s"
			size="s"
			icon={type === 'heat' ? 'fat fa-temperature-hot' : 'fat fa-temperature-frigid'}
			title={capFirstChar(
				type === 'cool'
					? $format('label_cooling', { default: 'cooling' })
					: $format('label_heating', { default: 'heating' }),
			)}
		/>
	{:else}
		<ParameterCard
			class="mb-s"
			icon={type === 'heat' ? 'fas fa-temperature-hot' : 'fas fa-temperature-frigid'}
			title={capFirstChar(
				type === 'cool'
					? $format('label_cooling', { default: 'cooling' })
					: $format('label_heating', { default: 'heating' }),
			)}
		/>
	{/if}
{/if}

{#if $showNewLayout}
	<ParameterCardV2
		class="mb-s"
		size="s"
		icon="fat fa-temperature-three-quarters"
		title={`${thermostatDefTemp} °${units}`}
		description={capFirstChar($format('base_temperature', { default: 'base temperature' }))}
	/>
	<ParameterCardV2
		class="mb-s"
		size="s"
		icon="fat fa-temperature-three-quarters"
		title={internal_temperature === null || Boolean(!sensorIsOnline)
			? $format('device_status_offline', { default: 'Device is offline' })
			: `${internal_temperature}`}
		description={$format('label_sensor_temp', {
			default: 'Sensor temperature',
		})}
	/>
{:else}
	<ParameterCard
		class="mb-s"
		icon="fa-solid fa-temperature-three-quarters"
		title={`${thermostatDefTemp} °${units}`}
		description={capFirstChar($format('base_temperature', { default: 'base temperature' }))}
	/>
	<ParameterCard
		class="mb-s"
		icon="fa-solid fa-temperature-three-quarters"
		title={internal_temperature === null || Boolean(!sensorIsOnline)
			? $format('device_status_offline', { default: 'Device is offline' })
			: `${internal_temperature}`}
		description={$format('label_sensor_temp', {
			default: 'Sensor temperature',
		})}
	/>
{/if}
<ControlTempScheme {id} {showWheelTitle} {mode} {disabled} {internal_temperature} />

{#if showToggleBtn}
	<ControlEnableTempScheme {id} usedIn="drawer" />
{/if}
